import { slateChangeMerger, slateUpdatesIsEmpty } from './change-slate.utils';
import { compileSlate } from './slate-compiler.utils';
export const getSlateProps = (slateKitProps, slateProps, customMode) => {
    const { mode: slateKitMode, context: slateKitContext, updateSlateById, revertSlateUpdatesById, } = slateKitProps;
    const { rawSlate: slate, context } = slateProps;
    const mode = customMode || (slateKitMode === 'edit' ? 'edit' : 'live');
    const generalSlateUpdates = slateKitContext.slateUpdates || {};
    const slateUpdates = generalSlateUpdates[slate === null || slate === void 0 ? void 0 : slate.id] || {};
    const compiledSlate = compileSlate({ slate, slateUpdates });
    const blocksOutput = Object.values(compiledSlate.components).reduce((preValue, value) => {
        var _a;
        return (Object.assign(Object.assign({}, preValue), { [value.id]: (_a = value) === null || _a === void 0 ? void 0 : _a.output }));
    }, {});
    const updateSlate = (newChanges) => {
        const compiledUpdates = slateChangeMerger(compileSlate({ slate, slateUpdates: {} }), slateUpdates, newChanges);
        if (slateUpdatesIsEmpty(compiledUpdates)) {
            revertSlateUpdatesById(slate.id);
        }
        else {
            updateSlateById(slate.id, compiledUpdates);
        }
    };
    const updateComponentById = (componentId, input) => {
        updateSlate({ updatedComponents: [Object.assign({ id: componentId }, input)] });
    };
    const revertSlateUpdates = () => {
        revertSlateUpdatesById(slate.id);
    };
    const updateBlockOutput = (componentId, output) => {
        updateComponentById(componentId, { output });
    };
    return {
        mode,
        editable: compiledSlate.editable,
        rawSlate: slate,
        slate: compiledSlate,
        context: Object.assign(Object.assign({}, context), { network: slateKitContext.network, visitor: slateKitContext.visitor, blocksOutput }),
        updateSlate,
        updateComponentById,
        revertSlateUpdates,
        updateBlockOutput,
    };
};
//# sourceMappingURL=slate-props.utils.js.map